module.exports = __webpack_public_path__ + "img/image_card_three.7fe6d8c6.png";